module.exports = __webpack_public_path__ + "img/2.01f1e352.jpg";